import styled from 'styled-components';
import { Button } from '../../components';
import { colors, fonts } from '../../styles/theme';

export const WrapperStyled = styled.div`
  display: grid;
  grid-template-columns: 23% calc(100% - 23%);
  height: 100vh;
`;

export const LeftStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.color1};
`;

export const RightStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const RightContentStyled = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  flex-flow: column nowrap;

  h1 {
    color: ${colors.color1};
    margin-top: 1rem;
    margin-bottom: 1rem;
    line-height: 1.2;
    ${fonts.gotham.H26M};
  }

  span {
    margin-bottom: 3rem;
    text-align: center;
    ${fonts.lato.H16}
    line-height: 1.2;
  }

  a {
    color: ${colors.color1};
    &:hover {
      color: ${colors.color2};
    }
  }
`;

export const ButtonAreaStyled = styled.div`
    display: flex;
`;

export const ButtonStyled = styled(Button)`
    padding: 1rem 2rem;
    margin-right: 2rem;
`;
